// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2hRcR","buttons":"SendReceipts_buttons__231vs","email":"SendReceipts_email__yHTaH","bookApptTitle":"SendReceipts_bookApptTitle__331un"};